import styled from "styled-components";

export const UploadAvatarWrapper = styled.div`
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  border-radius: 50%;

  &:focus {
    outline-offset: 6px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

export const CenteredModal = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const WhiteBackground = styled.div`
  background-color: white;
  padding: var(--sp-20);
  border-radius: 8px;
  width: calc(var(--u) * 400);
`;

export const IconContainer = styled.div`
  position: relative;
  width: calc(var(--u) * 100);
  height: calc(var(--u) * 100);
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ImgContainer = styled.div`
  position: relative;
  width: calc(var(--u) * 100);
  height: calc(var(--u) * 100);
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%; /* Corrigido: removida referência ao theme */
`;

export const StyledIcon = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  border: 0.5px solid #000000;
  border-radius: 50%; /* Corrigido: removida referência ao theme */
  justify-content: center;
`;

export const MaterialIcons = styled.div`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: calc(var(--u) * 100);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: var(--sp-16);
`;

export const Button = styled.button`
  position: relative;
  width: 100%;
  height: calc(var(--u) * 50);
  margin-top: var(--sp-20);
  margin-bottom: var(--sp-20);
  border-radius: 6px;
  background-color: #ffe460;
  color: black;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;
  &:hover {
    color: white;
    background-color: #ffc303;
  }
`;

export const UploadButton = styled.button`
  background-color: #f0f0f0;
  color: #333;
  font-size: var(--fs-base);
  padding: var(--sp-10) var(--sp-20);
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #ddd;
  }
`;

export const ProportionSlider = styled.input<{
  color: string;
  value?: number;
  max?: number;
}>`
  width: 100%;
  height: calc(var(--u) * 6);
  border-radius: 5px;
  outline: none;
  background: ${(props) => {
    const value = props.value ?? 0;
    const max = props.max ?? 1;
    return `linear-gradient(to right, ${props.color} ${
      (value * 100) / max
    }%, white ${(value * 100) / max}%)`;
  }};

  &::-webkit-slider-thumb,
  &::-moz-range-thumb,
  &::-ms-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
  }
`;
